const _excluded = ["className", "children"],
      _excluded2 = ["className", "children"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Card, Typography } from 'seagull';
import cn from 'classnames';
import styles from "./CommonComponents.module.scss";

const SuccessIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.7305 7.23047L7.79303 11.168L5.82428 9.19922",
  stroke: "currentColor",
  strokeWidth: "1.3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 0.65C13.6116 0.65 17.35 4.38842 17.35 9C17.35 13.6116 13.6116 17.35 9 17.35C4.38842 17.35 0.65 13.6116 0.65 9C0.65 4.38842 4.38842 0.65 9 0.65Z",
  stroke: "currentColor",
  strokeWidth: "1.3",
  strokeMiterlimit: "10"
}));

export const SuccessBox = props => {
  const {
    className,
    children
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(className, styles.sucessBox)
  }), /*#__PURE__*/React.createElement(SuccessIcon, null), /*#__PURE__*/React.createElement(Typography, {
    style: {
      marginInlineStart: '8px'
    }
  }, children));
};
export const ErrorBox = props => {
  const {
    className,
    children
  } = props,
        rest = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(className, styles.errorBox)
  }), children);
};
export const ImportCard = props => {
  const {
    children,
    title,
    subtitle,
    actionsStart,
    actionsEnd
  } = props;
  return /*#__PURE__*/React.createElement(Card, {
    padding: "m",
    className: styles.cardRoot
  }, /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    weight: "normal"
  }, title), subtitle && /*#__PURE__*/React.createElement(Typography, null, subtitle)), /*#__PURE__*/React.createElement("div", null, children), (actionsStart || actionsEnd) && /*#__PURE__*/React.createElement("div", {
    className: styles.cardActions
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.cardActionBlock
  }, actionsStart), /*#__PURE__*/React.createElement("div", {
    className: styles.cardActionBlock
  }, actionsEnd)));
};